<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="ticketLoader">
		</AccountDetailComponent>
		<b-row>
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Tickets</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end align-items-center">
								<router-link v-if="!ticketLoader" to="/accounts/account/create-ticket/">
									<i class="fa fa-ticket"></i> Agregar Ticket
								</router-link>
								<div v-if="ticketLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
								<div v-if="!ticketLoader && ticketsList && ticketsList.length > 0" class="ml-2">
									<b-button variant="link"
											  class="text-success"
											  @click="exportToExcel"
											  v-b-tooltip.hover title="Descargar listado en Formato Excel">
										<i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
									</b-button>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body class="table-responsive">
						<b-table :items="ticketsList"
								 :current-page="currentPageTickets"
								 :per-page="perPage"
								 :fields="ticketTableFields"
								 :busy="ticketLoader"
								 show-empty
								 striped
								 empty-filtered-text="No hay tickets disponibles"
								 empty-text="No hay tickets disponibles"
								 head-variant="light">
							<template v-slot:table-busy>
								<div class="text-center text-info my-2">
									<b-spinner class="align-middle"></b-spinner>
								</div>
							</template>
							<div slot="createdAt" slot-scope="item">
								{{item.item.createdAt | dateFormatFull}}
							</div>
							<div slot="detail" slot-scope="item">
								<router-link :to="{name: 'TicketDetail', params: {id: item.item.ticketID}}">
									Ver Detalle
								</router-link>
							</div>
						</b-table>
						<nav class="d-flex justify-content-center" v-if="totalTicketsRows > perPage">
							<b-pagination
								:total-rows="totalTicketsRows"
								:per-page="perPage"
								v-model="currentPageTickets"
								prev-text="<<"
								next-text=">>"
								hide-goto-end-buttons/>
						</nav>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import XLSX from "xlsx";

	export default {
		name: "TicketList",
		components: {
			AccountDetailComponent,
			GoBackComponent
		},
		data: function () {
			return {
				perPage: 10,
				currentPageTickets: 1,
				ticketLoader: false,
				ticketsList: [],
				accountSelected: '',
				ticketTableFields: {
					ticketNumber: {
						label: '# Ticket'
					},
					createdAt: {
						label: 'Fecha de Creación'
					},
					priority: {
						label: 'Prioridad'
					},
					description: {
						label: 'Problema o Necesidad'
					},
					stateCodeStr: {
						label: 'Estado'
					},
					statusCodeStr: {
						label: 'Razon para el Estado'
					},
					detail: {
						label: 'Detalles'
					}
				},
			}
		},
		methods: {
			getTickets() {
				this.ticketLoader = true;
				this.$store.dispatch('getTickets')
					.then((tickets) => {
						this.ticketsList = tickets;
					})
					.finally(() => {
						this.ticketLoader = false;
					})
			},
			exportToExcel() {
				let newList = this.ticketsList.map(function (obj) {
					return {
						'# Ticket': obj.ticketNumber,
						'Fecha Creación': obj.createdAt,
						'Prioridad': obj.priority,
						'Problema o Necesidad': obj.description,
						'Estado': obj.stateCodeStr,
						'Razón para el Estado': obj.statusCodeStr,
					};
				});

				let data = XLSX.utils.json_to_sheet(newList);
				const workbook = XLSX.utils.book_new();
				const filename = 'tickets';
				XLSX.utils.book_append_sheet(workbook, data, filename);
				XLSX.writeFile(workbook, `${filename}.xlsx`);
			}
		},
		mounted() {
			if (this.$store.state.accountSelected !== '') {
				this.accountSelected = this.$store.state.accountSelected;
				this.getTickets();
			} else {
				this.$router.push('/accounts/');
			}
		},
		computed: {
			totalTicketsRows: function () {
				return this.ticketsList.length;
			}
		}
	}
</script>

<style scoped>

</style>
